import { Icon } from "@opendash/icons";
import { observer } from "mobx-react-lite";
import React from "react";

type Props = {
  onClick: () => void;
  color: string;
};

/**
 * Used by SourceTag.
 */
export const SourceFilterIcon = observer((props: Props) => {
  return (
    <Icon
      icon="fa:wrench"
      onClick={props.onClick}
      cursor="pointer"
      style={{ color: props.color }}
    />
  );
});
